import NokiaFull from 'marketing-website/components/icons/NokiaFull';
import heroImage from 'marketing-website/media/images/pages/case-studies/nokia/nokia-hero.jpg';
import image1 from 'marketing-website/media/images/pages/case-studies/nokia/nokia-1.jpg';
import image2 from 'marketing-website/media/images/pages/case-studies/nokia/nokia-2.jpg';

const nokiaAssets = {
  heroLogo: NokiaFull,
  statsImage: {
    src: heroImage,
    srcSet: heroImage,
    alt: 'A large Nokia logo on a wall',
  },
  stats: [
    {
      id: 0,
      stat: '90,000',
      title: 'Employees',
      copy: 'Located all around the world',
    },
    {
      id: 1,
      stat: '5',
      title: 'UX design team locations',
      copy:
        'The UX teams are spread across India, Bulgaria, Canada, Portugal and Finland. Marvel helps them work successfully across all these different time zones.',
    },
    {
      id: 2,
      stat: '320',
      title: 'People using Marvel',
      copy:
        'All happily collaborating on design ideas, across the entire company.',
    },
  ],
  singleImages: {
    first: {
      src: image1,
      srcSet: image1,
      alt: 'Two people sit at a table with laptops having a discussion',
      maxWidth: 1350,
    },
    second: {
      src: image2,
      srcSet: image2,
      alt: 'A group of people sit around a table in a meeting room',
      maxWidth: 1350,
    },
  },
};

export default nokiaAssets;



// WEBPACK FOOTER //
// ./src/configs/caseStudies/nokia.js